import { useTranslation } from "react-i18next";
import config from "config/config";

export const useAgentFaqs = () => {
  const { t } = useTranslation();
  return [
    {
      title: t("AgentFaq-title-1"),
      desc: t("AgentFaq-desc-15"),
    },
    {
      title: t("AgentFaq-title-2"),
      desc: t("AgentFaq-desc-16"),
    },
    {
      title: t("AgentFaq-title-3"),
      desc: t("AgentFaq-desc-17"),
    },
    {
      title: t("AgentFaq-title-4"),
      desc: t("AgentFaq-desc-18", { companyEmail: config.AGENT_SERVICE_EMAIL }),
    },
    {
      title: t("AgentFaq-title-5"),
      desc: t("AgentFaq-desc-19"),
    },
    {
      title: t("AgentFaq-title-6"),
      desc: t("AgentFaq-desc-20"),
    },
    {
      title: t("AgentFaq-title-7"),
      desc: t("AgentFaq-desc-21"),
    },
    {
      title: t("AgentFaq-title-8"),
      desc: t("AgentFaq-desc-22"),
    },
    {
      title: t("AgentFaq-title-9"),
      desc: t("AgentFaq-desc-23"),
    },
    {
      title: t("AgentFaq-title-10"),
      desc: t("AgentFaq-desc-24"),
    },
    {
      title: t("AgentFaq-title-11"),
      desc: t("AgentFaq-desc-25"),
    },
    {
      title: t("AgentFaq-title-12"),
      desc: t("AgentFaq-desc-12"),
      FileName: t("AgentFaq-file-name-12"),
    },
    {
      title: t("AgentFaq-title-15"),
      desc: t("AgentFaq-desc-26"),
    },
    {
      title: t("AgentFaq-title-28"),
      desc: t("AgentFaq-desc-28"),
    },
    {
      title: t("AgentFaq-title-29"),
      desc: t("AgentFaq-desc-29"),
      FileName: t("AgentFaq-file-name-29"),
      FileName2: t("AgentFaq-file-name-29-1"),
    },
    {
      title: t("AgentFaq-title-30"),
      desc: t("AgentFaq-desc-30"),
    },
  ];
};

export const useVestedAgentsFaqs = () => {
  const { t } = useTranslation();
  return [
    {
      title: t("AgentFaq-title-12"),
      desc: t("AgentFaq-desc-12"),
      FileName: t("AgentFaq-file-name-12"),
    },
  ];
};
